var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"friend"},[_c('div',{staticClass:"site-content"},[_c('section-title',[_c('div',{staticClass:"friend-header"},[_c('div',{staticClass:"title"},[_vm._v("暂未开放，小陈情绪员正在努力构思中！！！")])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }